import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router";
import { UserProvider } from './contexts/UserContext';
import { CartsProvider } from './contexts/CartContext';

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <UserProvider>
      <CartsProvider>

        <App />

        </CartsProvider>      

      </UserProvider>
    </React.StrictMode>
  </BrowserRouter>
);

